var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserCircleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 53,
    viewBox: "0 0 54 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9895 4.41666C15.0181 4.41666 4.90617 14.5286 4.90617 26.5C4.90617 38.4714 15.0181 48.5833 26.9895 48.5833C38.9609 48.5833 49.0728 38.4714 49.0728 26.5C49.0728 14.5286 38.9609 4.41666 26.9895 4.41666ZM26.9895 15.4583C30.8033 15.4583 33.6145 18.2673 33.6145 22.0833C33.6145 25.8993 30.8033 28.7083 26.9895 28.7083C23.1779 28.7083 20.3645 25.8993 20.3645 22.0833C20.3645 18.2673 23.1779 15.4583 26.9895 15.4583ZM15.7138 37.0382C17.6946 34.1232 20.9983 32.1798 24.7812 32.1798H29.1978C32.9829 32.1798 36.2844 34.1232 38.2653 37.0382C35.443 40.0592 31.4393 41.9583 26.9895 41.9583C22.5397 41.9583 18.536 40.0592 15.7138 37.0382Z",
    fill: "#CBC4F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCircleIcon);
export default __webpack_public_path__ + "static/media/user-circle-icon.a1dee60bc3b520faa69a1753e9ecc251.svg";
export { ForwardRef as ReactComponent };